import { createContext, useContext, useState } from 'react';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [admin, setAdmin] = useState(() => {
    const token = localStorage.getItem('adminToken');
    const name = localStorage.getItem('adminName');
    return token ? { token, name } : null;
  });

  const loginAdmin = (token, name) => {
    localStorage.setItem('adminToken', token);
    localStorage.setItem('adminName', name);
    setAdmin({ token, name });
  };

  const logoutAdmin = () => {
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminName');
    setAdmin(null);
  };

  return (
    <AuthContext.Provider value={{ admin, loginAdmin, logoutAdmin }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
